import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardHeader,
  Container,
  Divider,
  makeStyles,
} from "@material-ui/core";

import Page from "src/components/Page";
import MaterialTable from "material-table";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBudgetAdjustmentVerifier } from "src/redux/actions/budgetAdjustment.action";
import { priceNumberFormat } from "src/utils/Number";
import { hasRole, isAllowed } from "src/utils/Auth";
import Moment from "moment";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,

    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const VerifyBudgetAdjustmentRequisitionComponent = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { budgetAdjustments } = useSelector(
    (state) => state.budgetAdjustmentReducer
  );

  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  const {
    result: { countryid },
  } = useSelector((state) => state.loginReducer);

  useEffect(() => {
    if (
      hasRole(authorizePR.data, ["verifier-budget-adjustment", "super-admin"])
    ) {
      dispatch(getBudgetAdjustmentVerifier(countryid));
    }
    return () => {};
  }, []);

  if (budgetAdjustments.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert —{" "}
          <strong>Get Budget Adjustment Requisition data!</strong>
        </Alert>
      </div>
    );
  }

  return (
    <Page className={classes.root} title="Budget Adjustment">
      <Container maxWidth={false}>
        <Box mb={2}>
          <Card>
            <CardHeader
              subheader="For review budget adjustment on the system."
              title="Verify Budget Adjustment"
            />
            <Divider />
          </Card>
        </Box>
        <MaterialTable
          title
          columns={[
            { title: "Adjustment No.", field: "DOCUMENT_NO" },
            {
              title: "Request Date",
              field: "CREATED_AT",
              type: "date",
              render: (rowData) =>
                Moment(rowData.CREATED_AT).format("DD-MMM-YYYY"),
            },
            { title: "Requester", field: "REQUESTED_BY_NAME" },
            {
              title: "Brand",
              field: "BRAND_NAME",
            },
            {
              title: "Department",
              field: "DEPARTMENT_NAME",
            },
            {
              title: "Budget Amount",
              field: "AMOUNT",
              render: (rowData) => {
                return priceNumberFormat(rowData.AMOUNT);
              },
              filtering: false,
            },

            {
              title: "Currency",
              field: "CURRENCY_CODE",
            },
            {
              title: "Budget Type",
              field: "BUDGET_TYPE",
              lookup: { 1: "Investment", 0: "Expense" },
            },
            {
              title: "Adjustment Type",
              field: "ADJ_TYPE",
              lookup: {
                1: "Transfer",
                2: "Increase",
                3: "Decrease",
                4: "Return",
              },
            },
            {
              title: "Status",
              field: "STATUS",
              lookup: {
                1: "Prepared",
                2: "Re-Prepare",
                3: "Reviewed",
                4: "Reviewer Rejected",
                5: "Verified",
                6: "Verifier Rejected",
                7: "Cancelled",
              },
            },
          ]}
          isLoading={budgetAdjustments.isLoading}
          data={budgetAdjustments.data}
          actions={[
            {
              icon: "edit",
              tooltip: "Review",
              disabled: Boolean(
                !isAllowed(authorizePR.data, [
                  "can_view_budget_adjustment_requisition_detail",
                ])
              ),
              onClick: (event, rowData) => {
                history.push({
                  pathname: `/edit-budget-adjustment-requisition`,
                  state: rowData,
                });
              },
            },
          ]}
          options={{
            filtering: true,
          }}
        />
      </Container>
    </Page>
  );
};

export default VerifyBudgetAdjustmentRequisitionComponent;
